<template>
    <page-title
        title="発注履歴"
        icon="bi-clock-history"
    >
    </page-title>

    <div class="d-flex flex-wrap gap-2 align-items-end my-3">
        <div class="form-group col-14 col-md-8 col-lg-3">
            <label class="form-label">学校名</label>
            <input type="text" v-model="condition.school_keyword" class="form-control">
        </div>

        <div class="form-group col-24 col-md-14 col-lg-10">
            <label class="form-label">注文日</label>
            <div class="input-group">
                <input type="date" v-model="condition.order_date_from" class="form-control">
                <div class="input-group-append"><span class="input-group-text">〜</span></div>
                <input type="date" v-model="condition.order_date_to" class="form-control">
            </div>
        </div>

        <div class="form-group col-12 col-md-6 col-lg-4">
            <label class="form-label">アプリ</label>
            <form-select
                v-model="condition.app_key"
                :options="apps"
                option_key="app_key"
                option_label="app_name"
                empty_option="-- 選択 --"
            ></form-select>
        </div>

        <div class="form-group col-12 col-md-6 col-lg-4">
            <label class="form-label">ステータス</label>
            <form-select
                v-model="condition.order_status"
                :options="order_statuses"
                empty_option="-- 全て --"
            ></form-select>
        </div>

        <div class="form-group col text-end">
            <button-search @click="search()"></button-search>
        </div>
    </div>
    <inline-loader v-if="loading"></inline-loader>

    <div v-else>
        <div v-if="orders.length">
            <table-normal class="table">
                <thead>
                    <tr>
                        <th class="text-center">学校名</th>
                        <th class="text-center">アプリ</th>
                        <th class="text-center">ライセンス数</th>
                        <th class="text-center">ステータス</th>
                        <th class="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="order in orders" :key="order.order_id">
                        <td class="text-center">{{ order.school.school_name }}</td>
                        <td class="text-center">{{ order.app.app_name }}</td>
                        <td class="text-center">{{ order.total_account_number }}</td>
                        <td class="text-center">{{ order.order_status_display_for_distributor }}</td>
                        <td class="text-center">
                            <button-go-view :to="{ name: 'PageOrderDetail', params: {id: order.order_id} }" />
                        </td>
                    </tr>
                </tbody>
            </table-normal>
            <paginator :meta="paginator_meta" @move="search"></paginator>
        </div>

        <alert-no-record class="mt-5" v-else></alert-no-record>

    </div>
</template>

<script>
import PageTitle from '@/shared/components/design/PageTitle';
import AlertNoRecord from '@/shared/components/design/AlertNoRecord';
import TableNormal from '@/shared/components/design/TableNormal';
import ButtonSearch from '@/shared/components/design/buttons/ButtonSearch';
import ButtonGoView from '@/shared/components/design/buttons/ButtonGoView';
import InlineLoader from '@/shared/components/tool/InlineLoader';
import Paginator from '@/shared/components/tool/Paginator';
import FormSelect from '@/shared/components/form/FormSelect';
import OrderStatus from '@/shared/models/enums/order-status';
import Order from '@/shared/models/entities/order';

export default {
    name: 'PageOrderList',
    components: {
        FormSelect,
        InlineLoader,
        Paginator,
        PageTitle,
        AlertNoRecord,
        ButtonSearch,
        ButtonGoView,
        TableNormal,
    },
    data() {
        return {
            //部分ローダー
            loading: true,

            //選択肢
            apps: [],
            order_statuses: OrderStatus.optionsForDistributor(),

            //送信データ(検索用)
            condition: {
                school_keyword: null,
                order_date_from: null,
                order_date_to: null,
                app_key: null,
                order_status: null,
                page: 1,
            },
            //表示データ
            orders: [],

            //ページネーションデータ
            paginator_meta: {},
        }
    },
    mounted() {
        //storeに前回の検索条件があれば
        this.condition = this.$store.getters['distributor/condition/merge']('PageOrderList', this.condition);

        //select用アプリ一覧を取得
        this.$http.get('/distributor/app')
        .then(response => {
            this.apps = response.data;
        });
        this.search();
    },
    methods: {
        //検索
        search(page = 1) {
            this.loading = true;
            this.condition.page = page;
            this.orders = [];
            this.$http.get('/distributor/order', {
                params: this.condition
            })
            .then(response => {
                //検索結果を代入
                for (let row of response.data.data) {
                    this.orders.push(new Order(row));
                }
                //ページネーション用
                this.paginator_meta = response.data.meta;
                //検索条件を保存
                this.$store.commit('distributor/condition/setSearchCondition', {
                    page: 'PageOrderList',
                    condition: this.condition
                });
            })
            .finally(() => {
                this.loading = false;
            });
        },
    }
}
</script>

<style scoped>

</style>
